import posthog from 'posthog-js';
import { POSTHOG_APP_ID } from '@/store/constants';

export default {
    install(Vue) {
        posthog.init(POSTHOG_APP_ID, {
            api_host: 'https://app.posthog.com',
        });

        Vue.prototype.$posthog = posthog;
    },
};